<template>
  <v-app>
    <!--
    <app-header></app-header>
    -->
    <v-content pa-0 ma-0>
      <div class="full-width">
        <app-content></app-content>
      </div>
    </v-content>

    <v-alert :value="!accepted" class="text-xs-left"  color="#ececec" style="color:rgb(60,60,60);font-size:16px;margin: 2em 0 0 0;">
      <input type="checkbox" v-model="accepted">
      Damit wir Dich bedarfsgerecht und zielorientiert beraten können, erklärst Du Dich damit einverstanden, dass Deine eingegebenen Daten zum Zweck der Beratung von Versicherung-, Bauspar- und Bankprodukten von der Öffentlichen und dem für Dich zuständigen Vertriebspartner ausgewertet und genutzt werden dürfen. Zudem habe ich habe die aktuellen <a href="https://www.oeffentliche.de/content/oeffentliche/gesetzliche-regelungen/datenschutz/" target="_blank">Datenschutzrichtlinien</a> gelesen und akzeptiere sie. Diese Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen. Ihre Email-Adresse verwenden wir, um Ihnen eine Empfangsbestätigung Ihrer Anfrage zu senden, sowie für etwaige Rückfragen.

    </v-alert>
  </v-app>
</template>


<script>
  import AppContent from "./components/AppContent";
  import MapAgencyNumbersService from "./Services/MapAgencyNumbersService";

  export default {
    data(){
      return {
        showHint: true
      }
    },
    computed: {
        accepted: {
          get(){
            return this.$store.getters['getDsAccepted'];
          },
          set(value){
            this.$store.commit('SET_DS_ACCEPTED',value);
          }
        }
    },
    components: {AppContent},
    mounted(){
      let self = this;
      /**
       * Analyse agency number if given
       * A: if not available => set kanalType to 'vu'
       * B: if available and only one office is given => take that one
       * if available and multiple offices are given
       * C:   - if offices contains the request param kanalName => take that one
       * D:   - if offices does not contain kanalName => take offices[0]
       */
      if(this.$route.query.agenturNr != undefined){
        this.accepted = false;
        MapAgencyNumbersService.mapAgencyNrToOffices(this.$route.query.agenturNr)
                .then( function(response){
                    console.log("Die MP liefert zurück:");
                    console.dir(response);
                    if(response.data.offices.length > 0){
                      // return state.in.filter(inItem => inItem.index == index)[0];
                      let focus = response.data.offices.filter((office) => office.nummer === self.$route.query.kanalName);
                      console.log("Länge von focus ist " + focus.length);
                      console.dir(focus);
                      if(focus.length == 1) { // C and B
                        self.$store.state.qa.agency.nummer = focus[0].nummer;
                        self.$store.state.qa.agency.email = focus[0].niederlassungen[0].email;
                        self.$store.state.qa.agency.fax = focus[0].niederlassungen[0].fax;
                        self.$store.state.qa.agency.firma = focus[0].firmenbezeichnung;
                        self.$store.state.qa.agency.hpName = focus[0].urlShortcut;
                        self.$store.state.qa.agency.name = focus[0].name;
                        self.$store.state.qa.agency.ort = focus[0].niederlassungen[0].ort;
                        self.$store.state.qa.agency.plz = focus[0].niederlassungen[0].plz;
                        self.$store.state.qa.agency.strasse = focus[0].niederlassungen[0].strasseHausnr;
                        self.$store.state.qa.agency.tel = focus[0].niederlassungen[0].telefon;
                        self.$store.state.qa.agency.kanalType = 'vis';
                      }
                      else{ // D
                        // kanalName is not included => consider logging this case via mp service!
                        self.$store.state.qa.agency.nummer = response.data.offices[0].nummer;
                        self.$store.state.qa.agency.email = response.data.offices[0].niederlassungen[0].email;
                        self.$store.state.qa.agency.fax = response.data.offices[0].niederlassungen[0].fax;
                        self.$store.state.qa.agency.firma = response.data.offices[0].firmenbezeichnung;
                        self.$store.state.qa.agency.hpName = response.data.offices[0].urlShortcut;
                        self.$store.state.qa.agency.name = response.data.offices[0].name;
                        self.$store.state.qa.agency.ort = response.data.offices[0].niederlassungen[0].ort;
                        self.$store.state.qa.agency.plz = response.data.offices[0].niederlassungen[0].plz;
                        self.$store.state.qa.agency.strasse = response.data.offices[0].niederlassungen[0].strasseHausnr;
                        self.$store.state.qa.agency.tel = response.data.offices[0].niederlassungen[0].telefon;
                        self.$store.state.qa.agency.kanalType = 'vis';
                      }

                    }
                    else {
                      self.$store.state.qa.agency.kanalType = 'vu'; // A
                    }
                        })
                .catch();
      }
      else {
        this.$store.state.qa.agency.nummer = this.$route.query.kanalName;
        this.$store.state.qa.agency.email = this.$route.query.email;
        this.$store.state.qa.agency.fax = this.$route.query.fax;
        this.$store.state.qa.agency.firma = this.$route.query.firma;
        this.$store.state.qa.agency.hpName = this.$route.query.hpName;
        this.$store.state.qa.agency.name = this.$route.query.name;
        this.$store.state.qa.agency.ort = this.$route.query.ort;
        this.$store.state.qa.agency.plz = this.$route.query.plz;
        this.$store.state.qa.agency.strasse = this.$route.query.strasse;
        this.$store.state.qa.agency.tel = this.$route.query.tel;
        this.$store.state.qa.agency.kanalType = this.$route.query.kanalType;
      }

    }
  }
</script>

<style lang="scss">

  @font-face{
    src: url('/fonts/BrixSansRegular.otf');
    font-family: "BrixRegular";
    font-style: normal;
    font-weight: 400;
  }

  @font-face{
    src: url('/fonts/BrixSansBold.otf');
    font-family: "BrixBold";
    font-style: normal;
    font-weight: 400;
  }

  html, body  {
    font-family: 'BrixRegular' !important;
    font-size: 34px !important;
    color: #002EA7;
  }

  h1, h2, h3, h4 {
    font-weight: normal;
  }



  .application {
    font-family: "BrixRegular" !important;
    background-color: transparent !important;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #002EA7;
  }
</style>
